module.exports = __webpack_public_path__ + "static/media/12_Lee_L@3x.ee9f4a75.jpg";